import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=f85a680e&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=f85a680e&prod&lang=sass&scoped=true"
import style1 from "./Index.vue?vue&type=style&index=1&id=f85a680e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85a680e",
  null
  
)

export default component.exports